module.exports = __webpack_public_path__ + "img/electric-gb3cb6744b_640.f5f43dc1.jpg";